import { ReactNode } from 'react';
import { Tag, TagProps, Tooltip } from 'antd';
import styled from 'styled-components';

type Props = Omit<TagProps, 'color'> & {
  children: ReactNode;
  title?: string;
  color?: TagProps['color'] | false;
};

export const IconTag = ({ children, title, ...rest }: Props) => {
  return (
    <Tooltip title={title}>
      <TagWrapper {...rest}>{children}</TagWrapper>
    </Tooltip>
  );
};

const TagWrapper = styled(Tag)`
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
`;
